// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".library-labels{margin:2rem 0}.library-labels__tag{background:#EDF2FF;border:none;font-weight:500;margin-bottom:0;font-size:1.1rem}.library-labels__tag--active{background:#ACE1FF}\n", ""]);
// Exports
module.exports = exports;
